module.exports = __webpack_public_path__ + "static/media/emailPicture.1ce28262.png";